module.exports = __webpack_public_path__ + "static/media/DSC_0038.8d872ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0038.jpg
// module id = 620
// module chunks = 0